<template>  
    <section :class='isShowStatus?"":"no-p"'>
		<!-- 是否设置截止时间弹框 -->
		<common-modal :showClose="true" v-if="isShowTime"  @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">是否设置截止时间</div>
		        <div class="time-common set-time" @click="showDatePicker">设置截止时间</div>
		        <div class="time-common no-time"  @click="noSetHandle">无需设置</div>
		    </div>
		</common-modal>
		
		<!-- 设置截止时间成功  撤单-->
		<confirm-modal v-if="isSetTime" :noWidth="true" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
		    @leftClick="goBackList" @rightClick="lookOrder">
		</confirm-modal>
		
		<!-- 派单时选择业务员信息 -->
		<common-modal :showClose="true" v-if="isDispatch"  @close-modal="onCloseModalClick">   
		    <div class="modal">
		        <div class="title">设置处理人员信息</div>
				<div class="sale-wrap">
					<p class="name-title">业务员</p>
					<select v-model="saleSelect" @blur="backHeight">
						<option v-for="(item,index) in salesMan" :key="index" :value="item.uuid">{{item.user_name}}</option>
					</select>
					<p class="name-title">佣金比例</p>
					<div class="commission-wrap">
						<input placeholder="请输入佣金比例" type="tel" v-model="money" @blur="backHeight"/>
						<span>%</span>
					</div>
				</div>
				<div class="submit-sale" @click="submitDispatch">提交</div>
		    </div>
		</common-modal>
		
		<!-- 是否处理成功弹框 -->
		<confirm-modal v-if="isSuccess" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_one" :firmRight="firmRight_one"
		    @leftClick="onCloseModalClick" @rightClick="submitSuccess">
		</confirm-modal>
		
		<!-- 是否完成订单弹框-->
		<confirm-modal v-if="isComplete" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitComplete">
		</confirm-modal>
		
		<!-- 是否撤回订单,确认退款，已驳回状态下的撤单弹框-->
		<confirm-modal v-if="isRevoke" :firmTitle="firmTitle_2" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitRevoke">
		</confirm-modal>
		
		<!-- 拒绝驳回 -->
		<refusal-modal v-if="isRefusal" @close-modal="onCloseModalClick"  @submit-refusal="submitRefusal"></refusal-modal>
		
		<!-- 退款 -->
		<common-modal :showClose="true" v-if="isRefund"  @close-modal="onCloseModalClick">	
		    <div class="modal">
		        <div class="title">退款</div>
				<div class="sale-wrap">
					<p class="name-title">退款金额</p>
					<div class="commission-wrap com-mb">
						<input placeholder="请输入退款金额" type="tel" v-model="refundMoney" @blur="backHeight"/>
					</div>
				</div>
					
				<div class="submit-sale" @click="submitRefund">提交</div>
		    </div>
		</common-modal>
        
		<!-- 撤单原因弹框 -->
		<common-modal :showClose="true" v-if="isRescind" @close-modal="onCloseModalClick">
			<div class="modal ">
			    <div class="title">{{rescindTitle}}</div>
			    <ul class="list-wrap che-dan">
                    <li v-if="rescindFlag">
                        <div v-for="(item,index) in rescindList" :key="index" class="com-mb">
                            <span class="select-mark" @click="selectFlag=index" :class='selectFlag==index?"done":"undone"'></span>
                            <span class="modal-text">{{item}}</span>
                        </div>
                    </li>
                    <li v-if="selectFlag==3">
                    	<textarea class="textarea" :rows="8" v-model="otherReason" @blur="backHeight" placeholder="请详细描述撤单原因，便于管理员找商家谈条件，好提高成功率"/>
                    </li>
                    
                    <li class="admin-img">
                    	<div class="num">上传图片（{{addImages.length }}/6）</div>
                    	<imageUpload v-model="addImages" :limit="6" class="add-img"/>
                    </li>
			    </ul>
			    <div class="modal-submit" @click="submitRescind">提交</div>
			</div>
		</common-modal>
		
		<!-- 订单进度 -->
		<progress-bar :detailList="detailList" role="admin"></progress-bar>
		<!-- 服务项目信息 -->
		<service-items :detailList="detailList"></service-items>
		<handler-info  :detailList="detailList" v-if="detailList.salesman_uuid"></handler-info>    <!-- 处理人员信息 -->
		<contact-info  :detailList="detailList"></contact-info>
		<after-sale :detailList="detailList"></after-sale>
		<div class="order-detail" v-if="detailList.order_supplement">
		    <div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_6.png" alt="" class="pt-img">
		        <span class="link">补充信息</span>
		    </div>
			<p class="supply-content">{{detailList.order_supplement}}</p>
		    <div class="img-list">
		        <img v-for="(item,index) in detailList.order_supplement_img" :key="index" :src="item" alt="" @click="handleImgsClick(detailList.order_supplement_img,index)" class="img-size" />
		    </div>
		</div>
		<!--1待支付 2待处理 3 处理中 4待确认 5已完成 6 已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
		<!-- 处理中（未分配业务员) 已取消 无操作按钮 -->
		<div class="operat" v-if="isShowStatus">
			<!-- 2待处理 已指派派业务员-，未指派业务员 -->
			<div v-if="detailList.order_status==2">
				<span class="complete gen-jin un-click" v-if="detailList.salesman_uuid" @click="rescind(2)">撤回</span>
				<span class="complete" v-if="!detailList.salesman_uuid" 	   @click="dispatch">派单</span>
				<span class="complete un-click" @click="follow">进度</span>
			</div>
			
			<!-- 3处理中-->
			<div v-if="detailList.order_status==3" class="only-one">
				<span class="complete gen-jin un-click"  @click="rescind(2)">撤回</span>
				<span class="complete gen-jin un-click"  @click="handleSuccess">成功</span>
				<span class="complete gen-jin"          @click="follow">进度</span>
			</div>
			
			<!-- 4 待确认 -->
			<div class="only-one" v-if="detailList.order_status==4">
				<span class="complete gen-jin un-click" @click="rescind(2)">撤回</span>
				<span class="complete un-click" 		   @click="follow">进度</span>
			</div>
			
			<!-- 5 已完成 -->
			<div class="only-one" v-if="detailList.order_status==5">
				<span class="complete un-click" @click="follow">进度</span>
			</div>
			
			<!-- 6 已撤单 -->
			<p class="only-four" v-if="detailList.order_status==6 || detailList.order_status==13">	
				<span class="complete gen-jin"  @click="dispatch">派单</span>
				<!-- <span class="complete"  @click="revoke(9)">撤单</span> -->
                <span class="complete"  @click="rescind(1)">撤单</span>
				<span class="complete gen-jin"  @click="follow">进度</span>
			</p>
			
			<!-- 8 已驳回 -->
			<div class="only-four" v-if="detailList.order_status==8">
                <span class="btn-four gen-jin" @click="rescind(1)">撤单</span>
				<span class="btn-four" 		   @click="dispatch">派单</span>
				<span class="btn-four"		   @click="refusalReject">完成</span> <!-- 拒绝驳回 -->
				<span class="complete gen-jin" 		   @click="follow">进度</span>
			</div>

			<!-- 9 已退款-->
			<div class="only-one" v-if="detailList.order_status==9">
				<span class="complete gen-jin un-click"  @click="refund">退款</span>
				<span class="complete un-click" 			@click="follow">进度</span>
			</div>	
			
			<!-- 10 退款中-->
			<div class="only-one" v-if="detailList.order_status==10">
				<span class="complete gen-jin"  @click="revoke(11)">拒绝</span>
				<span class="complete" 	@click="revoke(3)">同意</span>
				<span class="complete gen-jin"  		@click="refund">退款</span>
				<span class="complete un-click" 			@click="follow">进度</span>
			</div>	
			
			<!-- 11 未解决-->
			<div class="only-one" v-if="detailList.order_status==11">
				<span class="complete gen-jin"  @click="dispatch">派单</span>
				<span class="complete un-click"  		@click="revoke(3)">即退</span>
				<span class="complete gen-jin" 			@click="follow">进度</span>
			</div>	
		</div>
    </section>
</template>

<script>
	import ProgressBar from '@/components/ProgressBar';
	import ContactInfo from '@/components/ContactInfo';
	import ServiceItems from '@/components/ServiceItems';
	import imageUpload from '@/components/ImageUpload';
	import RefusalModal from '@/components/RefusalModal'
    import CommonHeader from '@/components/CommonHeader'
    import ConfirmModal from '@/components/ConfirmModal'
    import CommonModal from '@/components/CommonModal'
	import HandlerInfo from '@/components/HandlerInfo'
	import AfterSale from '@/components/AfterSale'
	import {getOrderDetail,processingOrder,getSalesman,adminOrder} from '@/api/order'
    import utils from '@/assets/jslibs/utils'
    export default {
        name: 'service-order',
        data:function(){
            return {
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				isDispatch:false,		//派单时设置处理人员
				salesMan:[],
				saleSelect:"",			//选中派单的业务员
				money:"",               //佣金比例
				isComplete:false,       //是否完成功能订单弹框
				isRevoke:false,         //是否撤回订单，以及驳回状态下的是否撤单
				isRefund:false,       //是否退款
				refundMoney:"",       //退款金额   
				isRefusal:false,       //拒绝驳回
				reason:"",  		    //拒绝驳回理由
				isShowTime:false,      //是否设置时间弹框
				isSetTime:false,        //设置截止时间成功弹框 ,撤单成功弹框
				isSuccess:false,  		//是否处理成功弹框 
				isRescind:false,       //选择撤单原因弹框
				otherReason:"",        //撤单的其它原因
				addImages:[],          //上传的图片
                rejectImg:[],          //拒绝驳回图片
                firmTitle_1:"订单解决了吗？",
				firmLeft_one:"否",
				firmRight_one:"是",
                firmLeft_1:"取消",
                firmRight_1:"确定",
				firmTitle_2:"",
               
				firmTitle:"截止时间设置成功",
				firmLeft:"返回列表",
                firmRight:"查看订单",
				order_uuid:this.$route.query.order_uuid,
				detailList:{
					server_info:{}
				},
                rescindList:["客户不愿意协商","无法联系客户","商家要求撤单","其它原因"],
                reasons_for_cancellation:"",   //撤单理由
				selectFlag:0,
                wrapperHeight:"",
				notSale:true,
				num:null,		//判断是撤回订单还是,驳回状态下的撤单
				isShowStatus:false,			//是否展示按钮
                rescindFlag:true,
                rescindTitle:"请选择撤单原因"
            }
        },
        components: {
			ContactInfo,
			ServiceItems,
			imageUpload,
            ConfirmModal,
			RefusalModal,
            CommonModal,
            CommonHeader,
			HandlerInfo,
			AfterSale,
			ProgressBar
        },
		
		beforeCreate(){
			sessionStorage.removeItem("roleType");
		},
       
        created() {
            this.getOrderDetail();
			this.getSalesman()
        },
        
        mounted(){
            this.wrapperHeight = document.documentElement.clientHeight;
            document.title = "订单详情";
			window.addEventListener('touchmove', (event)=>{ 
			    if(this.isDispatch || this.isShowTime || this.isSetTime || this.isSuccess ||
				 this.isComplete || this.isClose || this.isRefusal || this.isRescind || this.isRefund){
			        event.preventDefault(); 
			    }
			}) 
        },
        
        methods: {
			//获取订单详情
			async getOrderDetail(){
				const { data, status } = await getOrderDetail(this.order_uuid);
				if (status !== 200) return 
				this.detailList = data;
				this.order_uuid = this.detailList.uuid;
				this.detailList.after_sale_name = utils.typeToName(this.detailList.after_sale_type);
				this.detailList.statusName = utils.statusToNameAdmin(this.detailList.order_status);
				this.detailList.question_url = this.detailList.question_url.split(",");
				if(this.detailList.order_status!=1 && this.detailList.order_status!=7){
					this.isShowStatus = true
				}
                // 补充信息
                if(this.detailList.order_supplement_img && this.detailList.order_supplement_img.length){
                    this.detailList.order_supplement_img.forEach((item,index)=>{
                		if(!item.includes("http") && !item.includes("https")){
                			this.detailList.order_supplement_img[index] = this.imgUrl + this.detailList.order_supplement_img[index];
                		}
                    })
                }
                
				if(this.detailList.order_status=="2" && !this.detailList.salesman_uuid){
					this.detailList.statusName = "等待分配处理人员"
				};
				
				if(this.detailList.statusName=="已退款"){
					this.detailList.statusName = "已关闭"
				};
				
				if(this.detailList.statusName=="已撤单"){
				    this.detailList.statusName = "已撤回"
				}
                
                if(this.detailList.commission_rate){//佣金比例
                    this.money =  Number( this.detailList.commission_rate)*100
                }
			},
			
			// 开始处理
			handle(){
			    this.isShowTime = true;
			},
			
			// 派单
			dispatch(index){
				this.isDispatch =true
			},
			
			// 处理成功
			handleSuccess(){
				this.isSuccess = true    //和设置时间成功共用弹框
			},
			
			//完成订单
			complete(){
				this.firmTitle_1="是否处理完成当前订单",
				this.isComplete = true    
			},
			
			// 撤回订单，拒绝退款，同意退款，回状态下的撤单
			revoke(num){
				this.num = num
				this.isRevoke= true;
				if(num=="3"){//退款
					this.firmTitle_2 = "是否立即退款"
				}
// 				else if(num=="4"){
// 					this.firmTitle_2 = "是否撤回该订单"
// 				}
// 				else if(num=="9"){//未解决状态下的撤单
// 					this.firmTitle_2 = "是否撤销该订单"
// 				}
				else if(num=="11"){//拒绝退款
					this.firmTitle_2 = "是否拒绝退款"
				}
			},
			
			// 撤单,撤回
			rescind(num){
				this.isRescind = true;
                if(num == 2){//撤回,此时只需要撤单理由输入框和上传图片
                    this.rescindFlag = false;
                    this.selectFlag = 3;
                    this.rescindTitle = "请选择撤回原因"
                }else{//撤单
                    this.rescindFlag = true;
                    this.selectFlag = 0;
                    this.rescindTitle = "请选择撤单原因"
                }
			},
			
			// 关闭订单
			close(){
				this.isClose= true    
			},
			
			// 退款
			refund(index){
				this.count = index;
				let backurl = location.href;
				this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid ,refund:"admin",backurl:backurl}})
			},
			
			// 拒绝驳回
			refusalReject(){
				this.isRefusal = true
			},
			
			//跟进记录
			follow(){
				this.$router.push({path:'./order-speed',query:{order_uuid:this.order_uuid,follow:"admin"}})
			},
			
			// 设置处理的截止时间
			showDatePicker() {
			    this.isShowTime = false;
			    if (!this.datePicker) {
			        this.datePicker = this.$createDatePicker({
			            title: '设置截止时间',
			            min: new Date(2008, 7, 8),
			            max: new Date(2020, 9, 20),
			            value: new Date(),
			            onSelect: this.selectHandle,
			            onCancel: this.cancelHandle
			        })
			    }
			    
			    this.datePicker.show()
			},
			
			//确定选择时间，并开始处理
			selectHandle(date, selectedVal, selectedText) {
			    this.deadline = selectedVal[0]+"-"+selectedVal[1]+"-"+selectedVal[2];
			    this.processingOrder();     //处理订单
			},
			
			//无需设置截止时间，直接开始处理
			noSetHandle(){
			    this.isShowTime = false;
				this.firmTitle = "订单开始处理中" 	//直接处理成功提示语不一样
			    this.processingOrder();
			},
			
			// 确认派单
			submitDispatch(){
				if(!(/^[1-9]\d*(,\d{3})*(\.\d{2})?$/).test(this.money)){
				    window.toast("佣金比例有误","txt");
				    return
				}
				if(this.money>100 || this.money<1){
					window.toast("佣金比例应在1-100之间","txt");
					return
				}
				this.isDispatch = false
				this.adminOrder("1");
			},
			
			//确认处理成功
			submitSuccess(){
				this.isSuccess = false
				this.adminOrder("2");          //确认处理成功订单
			},
			
			//确认完成订单
			submitComplete(){
				this.isComplete = false
				this.adminOrder("5");
			},
			
			// 确认拒绝驳回
			submitRefusal(reason,rejectImg){
                this.rejectImg = rejectImg;
				this.reason = reason;
				this.isRefusal = false
				this.adminOrder("7");
			},
			
			// 确定撤回，撤单
			submitRescind(){
                if(this.rescindFlag){//撤单的时候才有撤单原因选择模块
                    if(this.selectFlag<0 || this.selectFlag>4){
                    	window.toast("请选择撤单原因","txt");
                    	return
                    }
                }

				if(this.selectFlag==3){//撤单原因为其它，则需要输入原因
					if(!this.otherReason){
                        let tips= ""
                        if(!this.rescindFlag){
                            tips= "请输入撤回原因"
                        }else{
                            tips= "请输入撤单原因"
                        }
						window.toast(tips,"txt");
						return
					}
					
					if(this.otherReason.length>100){
                        let tips= ""
                        if(!this.rescindFlag){
                            tips= "撤回原因不得超过100字符"
                        }else{
                            tips= "撤单原因不得超过100字符"
                        }
						window.toast(tips,"txt");
						return
					}
                    
                    this.reasons_for_cancellation = this.otherReason;
				}else{
                    this.otherReason="";
                    this.reasons_for_cancellation = this.rescindList[this.selectFlag];
                }
				this.isRescind = false;

                if(!this.rescindFlag){//撤回
                    this.adminOrder("13");
                }
                else{                           //撤单
                    this.adminOrder("6");
                }
			},
			
			// 确认撤回订单，退款，驳回下的撤单
			submitRevoke(){
				this.isRevoke = false;
				if(this.num == "3"){//立即退款
					this.adminOrder("3");
				}
				else if(this.num == "11"){//拒绝退款
					this.adminOrder("11");
				}
			},
			
			//操作订单
			async adminOrder(type){
				let obj = {}
				if(type=="1"){//派单
                    let commission_rate = Number(this.money)/100;
					obj={type:type,salesman_uuid:this.saleSelect,commission_rate:commission_rate};
				}else if(type=="6" || type=="13"){//撤单,撤回
					obj={type:type,reasons_for_cancellation:this.reasons_for_cancellation,img:this.addImages};
				}else if(type=="2" || type=="3" || type=="4" || type=="5" || type=="9"|| type=="11"){//完成订单，处理成功订单,关闭,退款
					obj={type:type};
				}else if(type=="7"){//拒绝驳回
					obj={type:type,reason_for_rejection:this.reason,img:this.rejectImg};
				}
				const { data, status } = await adminOrder(this.order_uuid,obj);
				if (status !== 200) return
				if(type=="1"){//派单
					this.isDispatch = false;
					this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"dispatch"}})
				}else if(type=="6" || type=="13"){
					this.isRescind = false;
					if(!this.rescindFlag){
					    this.firmTitle = "撤回成功";
					}else{
					    this.firmTitle = "撤单成功";
					}
					this.isSetTime = true;
                    this.otherReason = "";
                    this.selectFlag = 0;
                    this.addImages =[]   
				}else if(type=="2" || type=="5" || type=="4" || type=="9"|| type=="11"){//处理成功,完成订单，
					this.getOrderDetail(this.order_uuid)	
				}else if(type=="3"){
					this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"refund"}})
				}else if(type=="7"){
					this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"refusalReject"}})
				}
				
			},
			
			// 开始处理订单
			async processingOrder(){
			    let obj={type:"1",deadline:this.deadline};
			    const { data, status } = await processingOrder(this.order_uuid,obj);
			    if (status !== 200) return  			
				this.isSetTime = true        //开始处理订单
			},
			
			// 返回列表,并重新获取状态,当前页面下直接关闭弹框
			goBackList(){
			    this.isSetTime = false;
				this.$router.push({path:'./myorder-admin'})
			},
			
			// 查看订单
			lookOrder(){
				this.isSetTime = false;
			    this.getOrderDetail(this.order_uuid)
			},

            // 关闭弹框
            onCloseModalClick(){
				this.isDispatch = false;
				this.isSuccess = false;
				this.isComplete = false;
				this.isClose = false;
				this.isRefund = false;
				this.isRefusal = false;
				this.isShowTime= false;
				this.isRescind = false;
                this.otherReason = "";
                this.selectFlag = 0;
				this.isRevoke = false;
                this.addImages =[];  
            },
			
			//获取所有业务员
			async getSalesman(){
				let obj={page_index:"1",page_size:"999"}
				const { data, status } = await getSalesman(obj);
				if (status !== 200) return  
				this.salesMan = data.data;
				this.saleSelect = this.salesMan[0].uuid;     //下拉框默认选中第一个
			},
			
			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			},
			
			backHeight(){
			    setTimeout(() => {
			        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
			        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			    }, 100);
			}
        }
    }
</script>
<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5;padding:10px 10px 57px 10px;}
    .no-p{padding-bottom: 10px}
	.list{overflow-y: scroll; width: 100%;height: 100%;};
	.banner{width: 375px;height: 100px;padding:27px 0 0 40px;font-size: 18px; font-family: PingFangSC-Medium;font-weight: 500;color: rgba(255,255,255,1);background: url(../../assets/images/home/pic_order_banner.png) no-repeat center center;background-size: cover}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family:PingFangSC-Medium;font-weight:500;}
	.order-detail{margin-bottom: 10px;background: #fff}
	.order-wrap{font-size: 0;height: 1.38666667rem;margin:0 10px;line-height: 1.38666667rem;display: -webkit-box;display: -ms-flexbox;display: -webkit-flex;display: flex;border-bottom: 0.026667rem solid #E5E5E5;align-items: center;font-weight: 500}
	.have-between{justify-content: space-between;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.order-left{color:rgba(51,51,51,1);font-size:13px;}
	.flex-right{flex: 1;text-align: right;color:rgba(65,132,244,1);}
	.add-font{font-size: 14px;font-weight: 600;}
	.un-boder{border: none;justify-content: space-between;}
	.server-wrap{display: flex;margin: 10px;padding: 10px;background: #fff;}
	.assess-icon{width: 58px;height: 60px;margin-right: 10px}
	.server-content{flex:1;display: flex;align-items: center;justify-content: space-between;}
	.server-name{font-size:15px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1)}
	.commission{padding-top: 8px;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);}
	.follow{height: 19px;font-size:12px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(245,171,21,1);}
	.money{padding-top: 8px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;}
	.show-link{width: 335px;padding: 10px;margin: 0 auto;color:rgba(74,74,74,1);font-size: 14px;box-sizing: content-box}
    .customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
    .info-style{color:rgba(74,74,74,1);font-size: 14px}
    .p-b{padding-bottom:8px}
    .f-s{color: #4a4a4a;font-size: 0.373333rem;}
    .un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
    .describe{color:rgba(74,74,74,1);font-size: 14px;padding: 0 10px 8px 10px;}
	.supply-content{padding: 10px 15px 15px 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);}
    .img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:0 10px}
    .img-size{width: 95px;height:95px;margin-right: 16px;margin-bottom: 7.5px}
	.img-list .img-size:nth-child(3n){margin-right: 0}
    .agree-img{width: 22px;height: 22px;margin-right: 8px;display: inline-block;vertical-align:middle}
    .agree{background: url(../../assets/images/home/pic_right2_pitchon.png) center center no-repeat;background-size: cover}
    .un-agree{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .agree-text{padding: 10px 22px 10px 15px}
    .agree-text p{font-size:14px;color:rgba(20,20,20,1);line-height:20px;margin-bottom: 10px}
    .operat{position: fixed;bottom: 0;left: 0;width: 375px;height: 50px;background: #fff}
	.operat div{padding-right: 10px;width: 100%;height: 100%;text-align: right;}
	
	.operat span{display: inline-block;width: 65px;height: 30px;margin-top: 10px;border-radius:2px;border: 1px solid rgba(153,153,153,1);text-align: center;line-height: 30px;color:rgba(153,153,153,1);font-size: 13px;}
	.reject{margin-left: 120px}
	.notes{margin-left: 20px}
	.operat .complete{margin-left: 10px;background:rgba(65,132,244,1);color:rgba(255,255,255,1);border: none}
	.only-one{float: right;margin-right: 20px;}
    .only-four{float: right;margin-right:20px;}
    .operat .btn-four{background:rgba(65,132,244,1);color:rgba(255,255,255,1);border: none;margin-left:10px;}
	.operat .gen-jin{border:1px solid rgba(65,132,244,1);color:rgba(65,132,244,1);background: #fff}
    /* 弹框 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 35px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
    .list-wrap{padding: 18px 21px 6px 21px;}
    .list-wrap li{margin-bottom: 10px}
    .select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
    .on{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:5px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}

	 /* 是否设置截止时间弹框 */
	.time-common{.w(277.5);.h(40);.l-h(40);margin:0 auto;border-radius:5px;text-align: center;.f-s(18);font-family:PingFangSC-Regular;font-weight:400;}
	.set-time{background:rgba(65,132,244,1);color:rgba(255,255,255,1);margin: 19px auto 20px auto}
	.no-time{background:rgba(255,255,255,1);border:1px solid rgba(207,207,207,1);color:rgba(153,153,153,1);}
	
	/* 撤单理由弹框 */
	.textarea{width: 278px;height: 105px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	/* .dankal-image-upload /deep/ .add-box{padding-left: 0 !important}
	.dankal-image-upload /deep/ .add-box /deep/ .add{width: 80px;height: 80px}
	.dankal-image-upload /deep/ p /deep/ .upload_img{width: 80px;height: 80px} */
	
	/* 派单选择业务员弹框 */
	.sale-wrap{padding:20px 25px 20px 22px;}
	.sale-wrap select{/* -webkit-appearance: none; */width: 100%;height: 40px;padding-left: 17px;margin-bottom: 14px;margin-top: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);}
	.name-title{font-size: 14px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(20,20,20,1);}
	.commission-wrap{width: 100%;height: 40px;margin-top: 10px;background: rgba(245,245,245,1);border-radius: 2px;border: 1px solid rgba(151,151,151,1)}
	.com-mb{margin-bottom: 14px}
	.commission-wrap input{width: 88%;height: 100%;padding-left: 17px;background: rgba(245,245,245,1);}
	.submit-sale{width:277.5px;height:40px;line-height: 40px;margin:0 auto;background:rgba(65,132,244,1);border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);text-align: center}

    .operat .un-click{background:#f5f5f5;color:#999;border-color:#f5f5f5;}
</style>
